import * as React from 'react';
interface IAlert {
    style?: {}; // inline style obj
    color?: string; // #000000
}
const Alert: React.FC<IAlert> = (props) => {
    const { color } = props;
    return (
        <svg
            width="45px"
            height="36px"
            viewBox="0 0 45 36"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <title>Artboard</title>
            <desc>Created with Sketch.</desc>
            <g id="Artboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="alert" transform="translate(4.000000, 3.000000)">
                    <path
                        d="M20.2347423,0.417717416 L37.8736229,29.6728197 C38.1216575,30.0841016 37.993334,30.6209925 37.5872634,30.8722104 C37.4520501,30.9555135 37.2970284,31 37.1385619,31 L1.86123141,31 C1.38540106,31 1,30.6092167 1,30.1277158 C1,29.9672156 1.04349219,29.8097683 1.1261704,29.6728197 L18.7646203,0.417717416 C19.012655,0.00643543557 19.5427429,-0.123098762 19.9488135,0.128119076 C20.0650798,0.200082519 20.1636908,0.299522913 20.2347423,0.417717416 Z"
                        id="Path"
                        fill="#CEE8F6"
                        fill-rule="nonzero"
                    ></path>
                    <path
                        d="M18.1843733,0 L27.3401386,15.2218794 M31.6639212,22.410559 L34.8823791,27.7604972 C35.1130668,28.1445685 34.9940715,28.6460434 34.6160358,28.8804142 C34.4901671,28.9589742 34.3453967,29 34.1980487,29 L10.3508735,29 M5.58848362,29 L0.801607382,29 C0.359133854,29 0,28.6351323 0,28.1855943 C0,28.0354574 0.0408106652,27.888812 0.11770655,27.7604972 L14.7966585,3.35713211"
                        id="Shape"
                        stroke="#3EA5D9"
                        stroke-width="4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                    <g id="Group" transform="translate(17.000000, 9.000000)" fill-rule="nonzero">
                        <g id="51ettq0rrb-link" fill="#000000">
                            <path
                                d="M1.429875,12.7437838 C2.1165,12.7437838 2.673375,13.3855135 2.673375,14.1772973 C2.673375,14.9695135 2.1165,15.6112432 1.429875,15.6112432 C0.74325,15.6112432 0.186375,14.9695135 0.186375,14.1772973 C0.186375,13.3859459 0.74325,12.7437838 1.429875,12.7437838 Z M1.429875,0.263351351 C2.097375,0.263351351 2.639625,0.868756757 2.671875,1.63113514 L2.673375,1.70291892 L2.673375,10.2927568 C2.673375,11.088 2.118,11.7323243 1.429875,11.7323243 C0.76275,11.7323243 0.220125,11.1264865 0.187875,10.3645405 L0.186375,10.2927568 L0.186375,1.70291892 C0.186375,0.907243243 0.74175,0.263351351 1.429875,0.263351351 Z"
                                id="51ettq0rrb"
                            ></path>
                        </g>
                        <g id="51ettq0rrb-link" fill="#3EA5D9">
                            <path
                                d="M1.429875,12.7437838 C2.1165,12.7437838 2.673375,13.3855135 2.673375,14.1772973 C2.673375,14.9695135 2.1165,15.6112432 1.429875,15.6112432 C0.74325,15.6112432 0.186375,14.9695135 0.186375,14.1772973 C0.186375,13.3859459 0.74325,12.7437838 1.429875,12.7437838 Z M1.429875,0.263351351 C2.097375,0.263351351 2.639625,0.868756757 2.671875,1.63113514 L2.673375,1.70291892 L2.673375,10.2927568 C2.673375,11.088 2.118,11.7323243 1.429875,11.7323243 C0.76275,11.7323243 0.220125,11.1264865 0.187875,10.3645405 L0.186375,10.2927568 L0.186375,1.70291892 C0.186375,0.907243243 0.74175,0.263351351 1.429875,0.263351351 Z"
                                id="51ettq0rrb"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Alert;
